<template>
  <StuckWorkWarningModal
    v-if="showStuckWorkModal"
    :visible="showStuckWorkModal"
    :payload="stuckWorkPayload"
    @close="closeStuckWorkModal"
  />
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue';
import { useStuckWorkWarning } from '@/composables/useStuckWorkWarning';

const StuckWorkWarningModal = defineAsyncComponent(() =>
  import('@/components/Manager/StuckWorkWarningModal.vue')
);

export default defineComponent({
  name: 'StuckWorkWarningProvider',
  components: { StuckWorkWarningModal },
  setup() {
    const { showStuckWorkModal, stuckWorkPayload, closeStuckWorkModal } = useStuckWorkWarning();

    return {
      showStuckWorkModal,
      stuckWorkPayload,
      closeStuckWorkModal,
    };
  },
});
</script>
